import { call, put } from "redux-saga/effects";
import { instructorCourseApi } from "@services/api";
import { getMyPurchasesActions } from "../slices";

function* getMyPurchasesWorker({ payload }) {
  try {
    yield put(getMyPurchasesActions.pending());
    const response = yield call(instructorCourseApi.getMyPurchases);
    yield put(getMyPurchasesActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getMyPurchasesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getMyPurchasesWorker };
